var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNight = function SvgNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "night_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#night_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M12 20q1.446 0 2.651-.457a9.2 9.2 0 0 0 2.217-1.205 12.4 12.4 0 0 1-3.736-2.062 11.7 11.7 0 0 1-2.741-3.143 11.9 11.9 0 0 1-1.47-3.967q-.4-2.168.066-4.55-2.19.862-3.579 2.92Q4.02 9.591 4.02 12q0 3.517 2.231 5.759 2.231 2.24 5.75 2.24m0 1q-1.979 0-3.62-.672a8.6 8.6 0 0 1-2.84-1.859 8.3 8.3 0 0 1-1.858-2.838Q3.019 13.978 3.02 12q0-2.983 1.697-5.302 1.696-2.319 4.476-3.189.495-.163.758.117.265.28.124.837-.5 2.158-.188 4.219a10.9 10.9 0 0 0 1.302 3.803q.99 1.742 2.61 3.054 1.62 1.313 3.738 1.96.55.157.657.541.105.386-.272.723a8.7 8.7 0 0 1-2.703 1.643A8.9 8.9 0 0 1 12 21"
  }))));
};
export default SvgNight;